import { createMemoryHistory, createRouter } from '@tanstack/react-router';

// routes
import { rootRoute } from '@rootScreen';
import { homeRoute, notFoundRoute, indexRoute } from '@pages/home';
import { helpRoute } from '@pages/help';
import { NodesRoute } from '@pages/nodes';

const routeTree = rootRoute.addChildren([
  indexRoute,
  homeRoute,
  helpRoute,
  NodesRoute,
  notFoundRoute,
]);

const memoryHistory = createMemoryHistory({
  initialEntries: ['/home'],
});

const router = createRouter({ routeTree});

export default router;
